import React from 'react'
import './pay.css'

function Confirmpayment2() {
  return (
    <div className='Confirmpay2-card-div  '>

    <div className=' c-p-header-cont2'>
    <div className='c-p-header-svg w-100 '>
    <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" fill="none">
  <path d="M42 0C65.1956 0 84 18.8034 84 41.999C84 65.1956 65.1956 83.999 42 83.999C18.8034 83.999 0 65.1956 0 41.999C0 18.8034 18.8034 0 42 0Z" fill="#D99D2B"/>
  <path d="M71.3591 25.0431C70.3029 26.8376 67.9229 27.3541 66.019 27.3754C57.4726 27.4696 48.7104 31.3007 43.4756 38.1772C38.5871 44.5979 35.5884 52.1255 32.056 59.3169C31.101 61.2604 24.8262 63.2615 24.1588 60.1656C22.7703 53.7125 22.0229 43.8323 13.9798 42.2018C12.1873 41.8392 11.8875 40.0902 13.0926 38.8891C14.556 37.4278 16.8711 36.9477 18.845 37.3477C22.9161 38.1721 26.243 40.8113 28.2856 44.3984C28.8852 45.4506 29.3683 46.5069 29.7713 47.5713C32.2555 42.6352 35.079 37.8966 38.9943 33.9723C46.8622 26.0841 58.0579 22.3502 69.041 22.2287C70.5469 22.2125 72.3212 23.4095 71.3591 25.0431Z" fill="white"/>
</svg>
    </div>
    <div className='c-p-header' >
      <p className='c-p-header-par '>
    Done!
      </p>
    </div>
    </div>
    <div className='c-data-div2   w-100' >
        <p className='c-p-par1'>   Thank you for choosing amun city </p>

    </div>

    <button className='Confirmpay-btn Confirmpay-btn-par' data-bs-dismiss="modal" aria-label="Close">OK</button>

    </div>
  )
}

export default Confirmpayment2
